// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","logo-btn__container":"Header_logo-btn__container__Ha8K-","logo":"Header_logo__eQM7L","connect-btn":"Header_connect-btn__248lP"};